import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, PrivateRoute, PermissionRoute, useAuth } from './components/Auth/AuthContext';
import { RegionProvider } from './context/RegionContext';
import Login from './components/Auth/Login';
import Unauthorized from './components/Auth/Unauthorized';
import DashboardPage from "./pages/DashboardPage";
import LeadGenFormPage from "./pages/LeadGenFormPage";
import PendingRegistrationPage from "./pages/PendingRegistrationPage";
import PendingTrainingPage from "./pages/PendingTrainingPage";
import PotentialLeadsPage from "./pages/PotentialLeadsPage";
import AgentManagementPage from "./pages/AgentManagementPage";
import { pagePermissions } from "./utils/permissionConfig";
import DisqualifiedPendingRegistrationPage from "./pages/DisqualifiedPendingRegistrationPage";

// Public route component
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace /> : children;
};

// Default route component that checks dashboard access
const DefaultRoute = () => {
  const { user, hasPermission } = useAuth();
  const hasDashboardAccess = hasPermission(pagePermissions.dashboard.resource, pagePermissions.dashboard.action);
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return hasDashboardAccess ? <DashboardPage /> : <Navigate to="/lead-form" replace />;
};

// Log the permissions for debugging
console.log('Page permissions configuration:', pagePermissions);

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* Unauthorized Route - doesn't check permissions */}
      <Route
        path="/unauthorized"
        element={
          <PrivateRoute>
            <Unauthorized />
          </PrivateRoute>
        }
      />

      {/* Root route with permission check */}
      <Route path="/" element={<DefaultRoute />} />

      {/* Protected Routes with Permissions */}
      <Route
        path="/dashboard"
        element={
          <PermissionRoute
            resource={pagePermissions.dashboard.resource}
            action={pagePermissions.dashboard.action}
          >
            <DashboardPage />
          </PermissionRoute>
        }
      />

      <Route
        path="/lead-form"
        element={
          <PermissionRoute
            resource={pagePermissions.leadForm.resource}
            action={pagePermissions.leadForm.action}
          >
            <LeadGenFormPage />
          </PermissionRoute>
        }
      />

      <Route
        path="/pending-registration"
        element={
          <PermissionRoute
            resource={pagePermissions.pendingRegistration.resource}
            action={pagePermissions.pendingRegistration.action}
          >
            <PendingRegistrationPage />
          </PermissionRoute>
        }
      />

      <Route
        path="/pending-training"
        element={
          <PermissionRoute
            resource={pagePermissions.pendingTraining.resource}
            action={pagePermissions.pendingTraining.action}
          >
            <PendingTrainingPage />
          </PermissionRoute>
        }
      />

      <Route
        path="/potential-leads"
        element={
          <PermissionRoute
            resource={pagePermissions.potentialLeads.resource}
            action={pagePermissions.potentialLeads.action}
          >
            <PotentialLeadsPage />
          </PermissionRoute>
        }
      />

      <Route
        path="/agent-management"
        element={
          <PermissionRoute
            resource={pagePermissions.agentManagement.resource}
            action={pagePermissions.agentManagement.action}
          >
            <AgentManagementPage />
          </PermissionRoute>
        }
      />

      {/* <Route
        path="/disqualified-registration"
        element={
          <PermissionRoute
            resource={pagePermissions.agentManagement.resource}
            action={pagePermissions.agentManagement.action}
          >
            <DisqualifiedPendingRegistrationPage />
          </PermissionRoute>
        }
      /> */}

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <RegionProvider>
          <ToastContainer />
          <AppRoutes />
        </RegionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
